
namespace RioERP.Enquiry {
    export class EnquiryColumns {
        static columnsKey = 'Enquiry.Enquiry';
    }
}